import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const { meet } = config.endpoints

const createLink = (data) => axios({
  method: 'post',
  url: meet.link,
  data,
  headers: getHeaders(true)
})

export default {
  createLink
}
